// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w9OGnX2xewIfbuMcVseR{justify-content:space-between;align-items:center;display:flex}.U1AmRr9T2cqQd3mqRDZk{margin:12px 0 32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phoneCheckrModalTitle": `w9OGnX2xewIfbuMcVseR`,
	"phoneCheckrModalDescription": `U1AmRr9T2cqQd3mqRDZk`
};
export default ___CSS_LOADER_EXPORT___;
